var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7474 10.1022L10.2482 13.7015C9.91649 13.9669 9.43829 13.9404 9.13791 13.64L6.85844 11.3605C6.55807 11.0601 6.53158 10.5819 6.79695 10.2502L10.3963 5.75107C12.0422 3.69373 14.534 2.49609 17.1687 2.49609C17.6291 2.49609 18.0023 2.86935 18.0023 3.32977C18.0023 5.96445 16.8047 8.45628 14.7474 10.1022Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8339 10.8329V14.4861C13.8339 14.8019 13.6555 15.0905 13.3731 15.2317L11.359 16.2388C11.1428 16.3469 10.8904 16.3559 10.6671 16.2634C10.4438 16.1709 10.2717 15.9861 10.1953 15.7568L9.66554 14.1676",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33082 10.8329L4.74169 10.3032C4.51241 10.2268 4.32759 10.0546 4.2351 9.83133C4.14262 9.60805 4.15157 9.35562 4.25965 9.13946L5.26674 7.12535C5.40795 6.84293 5.69659 6.6645 6.01235 6.6645H9.66554",
    fill: "#23242A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2888 17.1579L2.99609 17.5023L3.34053 15.2096C3.45226 14.4659 4.03611 13.882 4.77987 13.7703C5.31733 13.6895 5.86122 13.8686 6.24553 14.253C6.62983 14.6373 6.80894 15.1811 6.72818 15.7186C6.61643 16.4624 6.03256 17.0462 5.2888 17.1579Z",
    fill: "#23242A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8339 10.8329V14.4861C13.8339 14.8019 13.6555 15.0905 13.3731 15.2317L11.359 16.2388C11.1428 16.3469 10.8904 16.3559 10.6671 16.2634C10.4438 16.1709 10.2717 15.9861 10.1953 15.7568L9.66554 14.1676M6.33082 10.8329L4.74169 10.3032C4.51241 10.2268 4.32759 10.0546 4.2351 9.83133C4.14262 9.60805 4.15157 9.35562 4.25965 9.13946L5.26674 7.12535C5.40795 6.84293 5.69659 6.6645 6.01235 6.6645H9.66554M14.7474 10.1022L10.2482 13.7015C9.91649 13.9669 9.43829 13.9404 9.13791 13.64L6.85844 11.3605C6.55807 11.0601 6.53158 10.5819 6.79695 10.2502L10.3963 5.75107C12.0422 3.69373 14.534 2.49609 17.1687 2.49609C17.6291 2.49609 18.0023 2.86935 18.0023 3.32977C18.0023 5.96445 16.8047 8.45628 14.7474 10.1022ZM5.2888 17.1579L2.99609 17.5023L3.34053 15.2096C3.45226 14.4659 4.03611 13.882 4.77987 13.7703C5.31733 13.6895 5.86122 13.8686 6.24553 14.253C6.62983 14.6373 6.80894 15.1811 6.72818 15.7186C6.61643 16.4624 6.03256 17.0462 5.2888 17.1579Z",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBlack);
export default __webpack_public_path__ + "static/media/premium-black.a55d7e1e7c11c617a747791315c3652d.svg";
export { ForwardRef as ReactComponent };